import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
	form: {
		display: 'flex',
		flexDirection: 'column',
	},
}));
